import React from 'react'
import type { ReactNode } from 'react'
import { ArrowDownIcon, ArrowRightIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

interface TermChangeProps {
  changes: Record<string, unknown>
  diffField: string
  unit?: string
  showPercentDiff?: boolean
  formatChange: (change: number, unit?: string) => ReactNode
}

const TermChange = ({ changes, diffField, unit, showPercentDiff = true, formatChange }: TermChangeProps) => {
  const changeValue = changes?.[diffField]
  if (changeValue === undefined) {
    return null
  }

  if (Array.isArray(changeValue) && typeof changeValue[0] === 'number') {
    const [previous, current] = changeValue as [number, number]
    const change = Math.round((current - previous) * 100) / 100
    const changePercent = Math.round((current - previous) * 1000 / previous) / 10
    const ChevronIcon = change > 0 ? ChevronUpIcon : ChevronDownIcon

    return (
      <div className="flex items-center space-x-3 sm:space-x-6 flex-row-reverse sm:flex-row">
        <div className="space-x-1 sm:w-12">
          {formatChange(change, unit)}
        </div>
        {showPercentDiff && Number.isFinite(changePercent) && (
          <div className="text-xs flex text-gray-500 pr-4 sm:pr-0">
            <ChevronIcon className="w-4 h-4 mr-1"/>
            <span>
              {Math.abs(changePercent)} %
            </span>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <ArrowDownIcon className="w-8 text-gray-500 sm:hidden"/>
      <ArrowRightIcon className="w-8 text-gray-500 hidden sm:inline"/>
    </>
  )
}

export default TermChange
